import React, { Fragment } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { Data } from '../../components';
import GradientList from '../global/GradientList';
import KubernetesUI from './KubernetesUI';
import reliability from '../../assets/media/product/kubernetes/reliability.svg';
import preventDowntime from '../../assets/media/product/kubernetes/prevent-downtime.svg';
import developQuickly from '../../assets/media/product/kubernetes/develop-quickly.svg';

const ProductKubernetes = () => {
  const {
    file: {
      childDataYaml: { kubernetes: pageData },
    },
  } = useStaticQuery(graphql`
    query ProductKubernetesPageData {
      file(name: { eq: "product" }) {
        childDataYaml {
          kubernetes {
            intro {
              heading
              blurb
            }
            reliability {
              heading
              items {
                blurb
              }
            }
            preventDowntime {
              heading
              items {
                blurb
              }
            }
            developQuickly {
              heading
              items {
                blurb
              }
            }
          }
        }
      }
    }
  `);

  return (
    <Fragment>
      <section className="section section--large">
        <div className="section-titleWrapper">
          <h3 className="section-title product__k8s-introTitle u-textFluid--h2-h3">
            <Data>{pageData.intro.heading}</Data>
          </h3>
          <div className="section-titleSub">
            <Data markdown>{pageData.intro.blurb}</Data>
          </div>
        </div>
        <KubernetesUI />
      </section>
      <section className="section section--large product__section">
        <div className="section-titleWrapper">
          <h3 className="section-title u-textFluid--h2-h3">
            <Data>{pageData.reliability.heading}</Data>
          </h3>
        </div>
        <div className="product__gridBlock product__gridBlock--large">
          <img
            src={reliability}
            className="product__gridBlock--reliability"
            alt=""
          />
          <div className="product__gridBlock-content">
            <GradientList items={pageData.reliability.items} />
          </div>
        </div>
      </section>
      <section className="section section--large product__section">
        <div className="section-titleWrapper">
          <h3 className="section-title u-textFluid--h2-h3">
            <Data>{pageData.preventDowntime.heading}</Data>
          </h3>
        </div>
        <div className="product__gridBlock product__gridBlock--large">
          <img
            src={preventDowntime}
            className="product__gridBlock--preventDowntime"
            alt=""
          />
          <div className="product__gridBlock-content product__gridBlock-content--preventDowntime">
            <GradientList items={pageData.preventDowntime.items} />
          </div>
        </div>
      </section>
      <section className="section section--large product__section">
        <div className="section-titleWrapper">
          <h3 className="section-title u-textFluid--h2-h3">
            <Data>{pageData.developQuickly.heading}</Data>
          </h3>
        </div>
        <div className="product__gridBlock product__gridBlock--large">
          <img
            src={developQuickly}
            className="product__gridBlock--developQuickly"
            alt=""
          />
          <div className="product__gridBlock-content">
            <GradientList items={pageData.developQuickly.items} />
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default ProductKubernetes;
